export const RestMethod = Object.freeze({
	linesV2RecentList: 'imopenlines.v2.Recent.list',
	linesV2SessionAnswer: 'imopenlines.v2.Session.answer',
	linesV2SessionSkip: 'imopenlines.v2.Session.skip',
	linesV2SessionMarkSpam: 'imopenlines.v2.Session.markSpam',
	linesV2SessionPin: 'imopenlines.v2.Session.pin',
	linesV2SessionUnpin: 'imopenlines.v2.Session.unpin',
	linesV2SessionIntercept: 'imopenlines.v2.Session.intercept',
	linesV2SessionFinish: 'imopenlines.v2.Session.finish',
	linesV2SessionStart: 'imopenlines.v2.Session.start',
	linesV2SessionJoin: 'imopenlines.v2.Session.join',
	linesV2SessionTransfer: 'imopenlines.v2.Session.transfer',
});
